import { DateSeries } from '../../DataSeries';

export class Wrapper {
  /**
   * 
   * @param {TimeSeries} series 
   */
  constructor(series) {
    this.series = series;
    this.currentIndexCounter = -1;

    if (series instanceof DateSeries) {
      this.value = v => v ? v.getTime() : null;
    } else {
      this.value = v => v ?? null;
    }
  }

  currentDatum() {
    return this.series[this.currentIndexCounter] ?? null;
  }

  currentValue() {
    return (this.currentDatum() || {}).value ?? null
  }

  nextDatum() {
    return this.series[this.currentIndexCounter+1] ?? null;
  }

  nextIndex() {
    return (this.nextDatum() || {}).index ?? null;
  }

  advanceTo(indexValue) {
    if (this.value(this.nextIndex()) === this.value(indexValue)) {
      this.currentIndexCounter++;
      return this.currentValue();
    } else {
      return null;
    }
  }
}